import TwoToneText from 'ReusableComponents/TwoToneText';
import TileButton from 'ReusableComponents/TileButton/TileButton';
import { getResponseTool, getQuizName, } from 'lib';
import { styled } from '@mui/material/styles';
import { forwardRef, } from "react";
import { Row, Col, } from 'antd';
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import Paragraph from 'antd/es/typography/Paragraph';
import TranslatedText from "translations/TranslatedText";;

function getHeaderTextProblem(question) {
  const headers = [];
  question.tools.forEach((tool:any) => {
    if (tool.element.includes('HeaderText')) {
      const header = tool.questions['en'].replace(/( |<([^>]+)>)/ig, " ");
      headers.push(
        `<p style="text-align:center;">${header}</p>`
      );
    }
  });
  return headers.join('');
}

function getExampleTextProblem(question) {
  const examples = [];
  question.tools.forEach((tool:any) => {
    if (tool.element.includes('ExampleText')) {
      const example = tool.questions['en'].replace(/( |<([^>]+)>)/ig, " ");
      examples.push(
        `<p>${example}</p>`
      );
    }
  });
  return examples;
}

function getProblem(question) {
  const problemHeader = getHeaderTextProblem(question);
  const exampleHeader = getExampleTextProblem(question);
  const audio = question.tools.find(tool => tool.element === 'Audio');
  const selectBlank = question.tools.find(tool => tool.element === 'SelectBlankText');

  return (
    <Row style={{ flexDirection: 'column', marginBottom: '2%', }} type="flex" justify="center" align="middle">
      {
        problemHeader && (
          <Col>
            <Title level={4}>
              <span dangerouslySetInnerHTML={{ __html: problemHeader }} />
            </Title>
          </Col>
        )
      }
      {
        exampleHeader && (
          <Col>
            <Text>
              <span dangerouslySetInnerHTML={{ __html: exampleHeader }} />
            </Text>
          </Col>
        )
      }
      {
        audio && (
          <Col>
            <audio
              src={audio.mediaFiles[0].src}
              controls
            >
              Your browser does not support the
              <code>audio</code> element.
            </audio>
          </Col>
        )
      }
      {
        selectBlank && (
          <Col>
            <Text>
              <span dangerouslySetInnerHTML={{ __html: selectBlank.questions['en'] }} />
            </Text>
          </Col>
        )
      }
    </Row>
  )
}

function getRevealImagePicture(tool) {
  return tool.mediaFiles[0].src;
}

function getMultiChoiceRowPicture(tool) {
  const mediaFile = tool.mediaFiles.find((mediaFile) => mediaFile.is_answer === true);
  return mediaFile.src;
}

function getChinaQuizMultiChoiceRowPicture(tool) {
  const mediaFile = tool.mediaFiles.find((mediaFile) => mediaFile.is_answer === true);
  return mediaFile.src;
}

function getPicture(question) {
  const tool = getResponseTool(question);
  if (tool) {
    if (tool.element === 'RevealImage') return getRevealImagePicture(tool);
    if (tool.element === 'MultiChoiceRow') return getMultiChoiceRowPicture(tool);
    if (tool.element === 'MultiChoiceGrid') {
      if (getQuizName().includes('China Quiz')) return getChinaQuizMultiChoiceRowPicture(tool);
    }
  }
}

function getRevealTextAnswer(tool) {
  return <span dangerouslySetInnerHTML={{ __html: tool.questions['en'] }} />
  // return tool.questions['en'].replace(/( |<([^>]+)>)/ig, " ");
}

function getMultiChoiceRowAnswer(tool) {
  const title = tool.mediaFiles.find(mediaFile => mediaFile.is_answer).title;
  return <Title level={2}>{title}</Title>;
}

function getMultiChoiceGridAnswer(tool) {
  const title = tool.mediaFiles.find(mediaFile => mediaFile.is_answer).title;
  return <Title level={2}>{title}</Title>;
}

function getChinaQuizRevealTextAnswer(question) {
  const tool = question.tools.find((tool:any) => tool.element.includes('RevealText'));
  return tool.questions['en'].replace(/( |<([^>]+)>)/ig, " ");
}

function getMultiChoiceColAnswer(tool) {
  const question = tool.questions['en'];
  const title = tool.mediaFiles.find(mediaFile => mediaFile.is_answer).title;

  return (
    <>
      {question && <span dangerouslySetInnerHTML={{ __html: question }} />}
      <Title level={2}>{title}</Title>
    </>
  )
}

function getFillBlankTextAnswer(tool) {
  const question = 'Q: '+Object.values(tool.sentences['en']).map(value => {
    return value.hanzi.reduce(
      (previousValue, currentValue) => {
        if (currentValue === -1) return previousValue + '____';
        return previousValue + currentValue
      }, '');
  }).join('<br />');

  const hanzi = tool.sentences.correctAnswers.hanzi.filter(hanzi => hanzi !== null);
  const pinyin = tool.sentences.correctAnswers.pinyin.filter(pinyin => pinyin !== null);
  const answer = hanzi+','+pinyin;
  return <span dangerouslySetInnerHTML={{ __html: question+'<br />'+'A: '+answer }} />
}

function getRearrangeTextAnswer(tool) {
  const questionHanzi = tool.disarrangedText.disarranged.hanzi;
  const questionPinyin = tool.disarrangedText.disarranged.pinyin;
  const answers = tool.disarrangedText.arranged.map((arranged, index) => {
    return 'A'+(index+1)+'. '+arranged.hanzi+','+arranged.pinyin+'\n';
  }).join('<br />');
  const question = 'Q: '+questionHanzi+','+questionPinyin+'<br />';
  return <span dangerouslySetInnerHTML={{ __html: question+answers }} />
}

function getSelectBlankTextAnswer(tool) {
  // const selectBlank = question.tools.find(tool => tool.element === 'SelectBlankText');
  const options = [];
  tool.options['en'].forEach(option => {
    if (option.is_answer) {
      options.push(<Paragraph>{`${option.select}. ${option.value}`}</Paragraph>);
    }
  });
  return options;
  // const questionHanzi = tool.disarrangedText.disarranged.hanzi;
  // const questionPinyin = tool.disarrangedText.disarranged.pinyin;
  // const answers = tool.disarrangedText.arranged.map((arranged, index) => {
  //   return 'A'+(index+1)+'. '+arranged.hanzi+','+arranged.pinyin+'\n';
  // }).join('<br />');
  // const question = 'Q: '+questionHanzi+','+questionPinyin+'<br />';
  // return <span dangerouslySetInnerHTML={{ __html: question+answers }} />
}

function getAnswer(question) {
  let tool = getResponseTool(question);
  if (tool) {
    if (tool.element === 'RevealImage') return getRevealTextAnswer(tool);
    if (tool.element === 'MultiChoiceRow') return getMultiChoiceRowAnswer(tool);
    if (tool.element === 'MultiChoiceCol') return getMultiChoiceColAnswer(tool);
    if (tool.element === 'MultiChoiceGrid') {
      if (getQuizName().includes('China Quiz')) return getChinaQuizRevealTextAnswer(question);
      return getMultiChoiceGridAnswer(tool);
    }
    if (tool.element === 'FillBlankText') return getFillBlankTextAnswer(tool);
    if (tool.element === 'RearrangeText') return getRearrangeTextAnswer(tool);
    if (tool.element === 'SelectBlankText') return getSelectBlankTextAnswer(tool);
  }
}

export default forwardRef((props: any, ref: any) => {
  const questionName = 'Question '+props.question.name;
  const problem = getProblem(props.question);
  const picture = getPicture(props.question);
  const answer = getAnswer(props.question);

  return (
    <Row type="flex" justify="center"
         align="middle"
     >
      <Col span={24}>
        <Row style={{ marginBottom: '2%', }} type="flex" justify="center" align="middle">
          <Col>
            <TwoToneText text={questionName} />
          </Col>
        </Row>
        <Row style={{ marginBottom: '2%', }} type="flex" justify="center" align="middle">
          <Col>
            <Text style={{
              color: 'black', fontFamily: 'AvenirNextLTPro-Bold',
            }}>
              {problem}
            </Text>
          </Col>
        </Row>
        <Row type="flex" justify="center" align="top">
          {
            picture && answer && (
              <>
                <Col span={7} style={{ paddingRight: '2%' }}>
                  <TileButton
                    src={picture}
                    title={questionName}
                    setActiveButton={()=>{}}
                    index={0}
                    activeButton={1}
                    correctAnswer={false}
                    checkAnswer={()=>{}}
                  />
                </Col>
                <Col span={14} style={{ paddingLeft: '2%' }}>
                  <Text style={{
                    color: 'black', fontFamily: 'AvenirNextLTPro-Regular',
                  }}>
                    {answer}
                  </Text>
                </Col>
              </>
            )
          }
          {
            picture && !answer && (
              <Col>
                <TileButton
                  src={picture}
                  title={questionName}
                  setActiveButton={()=>{}}
                  index={0}
                  activeButton={1}
                  correctAnswer={false}
                  checkAnswer={()=>{}}
                />
              </Col>
            )
          }
          {
            !picture && answer && (
              <Col span={12} style={{ textAlign: 'center', }}>
                <Text style={{
                  color: 'black', fontFamily: 'AvenirNextLTPro-Regular',
                }}>
                  {answer}
                </Text>
              </Col>
            )
          }
          {
            !picture && !answer && (
              <TranslatedText id="student.message.finished.answers.noanswer" />
            )
          }
        </Row>
      </Col>
    </Row>
  );
})
